import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
  padding: ${props => props.padding || '5rem 0'};
  background-color: ${props => props.bgColor || 'transparent'};
`;

const SectionContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.md};
`;

const SectionHeader = styled.div`
  text-align: ${props => props.align || 'center'};
  margin-bottom: 3rem;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  position: relative;
  
  ${props => props.align === 'center' && `
    &:after {
      content: '';
      position: absolute;
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 4px;
      background-color: ${props.theme.colors.primary};
    }
  `}
  
  ${props => props.align === 'left' && `
    &:after {
      content: '';
      position: absolute;
      bottom: -15px;
      left: 0;
      width: 80px;
      height: 4px;
      background-color: ${props.theme.colors.primary};
    }
  `}
`;

const SectionSubtitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 400;
  color: ${props => props.theme.colors.lightText};
  margin-top: 1.5rem;
`;

const Section = ({ 
  children, 
  title, 
  subtitle, 
  align = 'center',
  bgColor,
  padding
}) => {
  return (
    <SectionContainer bgColor={bgColor} padding={padding}>
      <SectionContent>
        {(title || subtitle) && (
          <SectionHeader align={align}>
            {title && <SectionTitle align={align}>{title}</SectionTitle>}
            {subtitle && <SectionSubtitle>{subtitle}</SectionSubtitle>}
          </SectionHeader>
        )}
        {children}
      </SectionContent>
    </SectionContainer>
  );
};

export default Section;